import React from "react";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import HomePage from "./Pages/Home/HomePage";
import NavbarLogo from "./components/Header/NavbarLogo";
import Footer from "./components/Footer/Footer";
import JobList from "./Pages/JobListing/JobList";
import JobPortal from "./Pages/JobPortal/JobPortal";
import ProgrammeDetails from "./Pages/Programme/ProgrammeDetails";
import Programme from "./Pages/Programme/Programme";
import ProgrammeApply from "./Pages/Programme/ProgrammeApply";
import ProgrammeList from "./Pages/Programme/ProgrammeList";
import { Loader } from "./components/Loader";
import { Toast } from "./components/Toast";
import AboutUs from "./Pages/AboutUs/AboutUs";
import ContactUs from "./Pages/Contact/ContactUs";
import JobDetails from "./Pages/JobPortal/JobDetails";
import SignUp from "./Pages/Auth/SignUp";

// Layout wrapper to include Navbar & Footer
const Layout = () => (
  <>
    <Loader />
    <Toast />
    <NavbarLogo />
    <Outlet /> {/* This renders the current page component */}
    <Footer />
  </>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />, // Wrap all routes with the layout
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/jobPortal", element: <JobPortal /> },
      { path: "/jobPortal/joblist", element: <JobList /> },
      { path: "/programmedetail/:id", element: <ProgrammeDetails /> },
      { path: "/programme", element: <Programme /> },
      { path: "/onlineApplication/:id", element: <ProgrammeApply /> },
      { path: "/programmeList/:id", element: <ProgrammeList /> },
      { path: "/aboutUs", element: <AboutUs /> },
      { path: "/contactUs", element: <ContactUs /> },
      { path: "/jobPortal/jobDetails/:id", element: <JobDetails /> },
    ],
  },
  {
    path: "/signup", // Define the Signup route separately
    element: <SignUp />,
  },
]);

export default function AppRouter() {
  return <RouterProvider router={router} />;
}
